import { Button, CircularProgress } from "@material-ui/core";
import { WithTooltip } from "@common";

type Props = {
  disabled?: boolean;
  loading?: boolean;
  onClick: (e: React.SyntheticEvent<any>) => any;
  text: string;
  disabledInfo?: string;
};

export function QualityCheckButton(props: Props) {
  const { disabled, loading, onClick, text, disabledInfo } = props;

  const button = (
    <Button
      disabled={disabled}
      onClick={onClick}
      variant="outlined"
      size="small"
      color="primary"
      style={{
        borderRadius: 6,
        fontSize: "16px",
        height: "25px",
        fontWeight: 500,
        padding: "12px 16px"
      }}
      endIcon={loading ? <CircularProgress size={10} /> : null}
    >
      {text}
    </Button>
  );

  if (disabled && disabledInfo) {
    return (
      <WithTooltip title={disabledInfo}>
        <span>{button}</span>
      </WithTooltip>
    );
  }

  return button;
}
